export default function chunkBatch<T>(array: T[], itemMax: number): T[][] {
	const final: T[][] = [];
	let chunk: T[] = [];
	for (let i = 0; i < array.length; i++) {
		const element = array[i];
		if (i !== 0 && i % itemMax === 0) {
			// Its the beginning of the next one
			final.push(chunk);
			chunk = [element];
		} else {
			chunk.push(element);
		}
	}

	if (chunk.length > 0) {
		final.push(chunk);
	}

	return final;
}
